import { DEFAULT_TASKS } from './tasks.js';

const DAY_PREFIX  = 'r_day_';
const TASKS_KEY   = 'r_tasks';

export function formatDate(d = new Date()) {
  return d.toISOString().slice(0, 10);
}

export function saveDayData(date, taskId, done) {
  const data = getDayData(date);
  data[taskId] = done;
  localStorage.setItem(DAY_PREFIX + date, JSON.stringify(data));
}

export function getDayData(date) {
  const raw = localStorage.getItem(DAY_PREFIX + date);
  return raw ? JSON.parse(raw) : {};
}

export function getTasks() {
  const raw = localStorage.getItem(TASKS_KEY);
  return raw ? JSON.parse(raw) : DEFAULT_TASKS;
}

export function saveTasks(tasks) {
  localStorage.setItem(TASKS_KEY, JSON.stringify(tasks));
}

export function getHistory(days = 30) {
  const tasks = getTasks();
  const result = [];

  for (let i = days - 1; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const date = formatDate(d);
    const data = getDayData(date);
    const percent = calcPercent(tasks, data);
    result.push({ date, percent });
  }

  return result;
}

export function calcPercent(tasks, data) {
  if (!tasks.length) return 0;
  if (!Object.keys(data).length) return 0;
  let done = 0;
  tasks.forEach(t => {
    if (!!data[t.id]) done++;
  });
  return Math.round((done / tasks.length) * 100);
}

export function getStreak() {
  const tasks = getTasks();
  let streak = 0;
  for (let i = 0; i < 365; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const date = formatDate(d);
    const data = getDayData(date);
    const hasAnyActivity = Object.keys(data).length > 0;
    if (!hasAnyActivity && i > 0) break;
    if (hasAnyActivity) {
      const pct = calcPercent(tasks, data);
      if (pct >= 50) streak++;
      else if (i > 0) break;
    }
  }
  return streak;
}

export function getTaskStats(days = 30) {
  const tasks = getTasks();
  const counts = {};
  tasks.forEach(t => { counts[t.id] = { task: t, done: 0, total: 0 }; });

  for (let i = 0; i < days; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const date = formatDate(d);
    const data = getDayData(date);
    if (!Object.keys(data).length) continue;
    tasks.forEach(t => {
      counts[t.id].total++;
      if (!!data[t.id]) counts[t.id].done++;
    });
  }

  const arr = Object.values(counts).filter(c => c.total > 0);
  arr.sort((a, b) => (b.done / b.total) - (a.done / a.total));
  return arr;
}
